import { cx } from "@jugl-web/utils";
import { forwardRef, ReactNode } from "react";

export interface LiveChatUIMessageListProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUIMessageList = forwardRef<
  HTMLDivElement,
  LiveChatUIMessageListProps
>(({ children, className }, ref) => {
  return (
    <div
      ref={ref}
      className={cx(
        "jugl__custom-scrollbar flex flex-1 flex-col gap-3 py-8",
        className
      )}
    >
      {children}
    </div>
  );
});

LiveChatUIMessageList.displayName = "LiveChatUIMessageList";
